<template>
  <div class="form mt-7">
    <!-- 휴대폰 번호 및 인증 번호 폼 -->
    <PhoneSmsAuth
      ref="form"
      :request="request"
      :confirm="confirm"
      @expire="onExpire"
      @requestCode="requestCode"
      @confirmCode="confirmCode"
    />
  </div>
</template>

<script>
export default {
  components: {
    PhoneSmsAuth: () => import('@/components/auth/PhoneSmsAuth.vue'),
  },
  data() {
    return {
      request: {
        loading: false,
        success: false,
      },
      confirm: {
        loading: false,
        success: false,
        expired: false,
        form: {
          expirationTime: null,
          token: null,
        },
      },
    }
  },
  methods: {
    async onExpire() {
      this.confirm.expired = true
      await this.$swal.basic.alert({
        html: '발급된 인증번호의 유효기간이 만료되었습니다. <br />다시 입력해주세요.',
      })
    },
    async requestCode(phone) {
      if (this.request.loading) return

      try {
        this.request.loading = true
        const { data } = await this.$defaultV2Api.requestVerifications({
          phone,
          purpose: 'FIND_ID',
        })

        this.confirm.form.token = data.token
        this.confirm.form.expirationTime = data.expiredAt
        this.confirm.expired = false
        this.request.success = true

        this.$refs?.form?.$refs?.inputCode?.focus()
      } catch (e) {
        await this.$swal.basic.alert({
          html: e.message,
        })
        this.$refs?.form?.$refs?.inputPhone?.focus()
      } finally {
        this.request.loading = false
      }
    },
    async confirmCode(code) {
      if (this.confirm.loading) return

      try {
        this.confirm.loading = true
        const { data } = await this.$defaultV2Api.confirmVerifications(this.confirm.form.token, {
          code,
        })

        this.$emit('update:email', data.data.email)
        this.confirm.success = true
      } catch (e) {
        await this.$swal.basic.alert({
          html: e.message,
        })
        setTimeout(() => {
          this.$refs?.form?.clearCode()
          this.$refs?.form?.$refs?.inputCode?.focus()
        }, 50)
      } finally {
        this.confirm.loading = false
      }
    },
  },
}
</script>

<style></style>
